import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function SeoContent() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-[860px] mx-auto text-center">
        <div className="mb-10">
          <img
            src="https://readdy.ai/api/search-image?query=Delicate%20thin%20line%20abstract%20illustration%20of%20spreadsheet%20grid%20and%20product%20silhouettes%20in%20soft%20mint%20green%20tone%20on%20transparent%20background%20minimalist%20line%20art%20style%20with%20plenty%20of%20white%20space&width=800&height=160&seq=seo-decor-line&orientation=landscape"
            alt=""
            className="w-full max-w-[600px] mx-auto h-auto object-contain"
          />
        </div>

        <p className="text-xs md:text-sm font-label text-primary-600 uppercase tracking-[0.15em] mb-6">
          {t("seo_section_label")}
        </p>

        <div className="text-left md:text-center">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed md:leading-loose">
            {t("seo_section_text")}
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 mt-8">
          <Link
            to="/article/yoybuy-sheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t("seo_read_more")}
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 border-2 border-secondary-300 text-foreground-700 rounded-full text-sm font-semibold hover:border-secondary-500 hover:text-foreground-950 transition-all cursor-pointer whitespace-nowrap"
          >
            {t("nav_yoybuy_sheet")}
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-external-link-line"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}